import { Component, EventEmitter, Output } from '@angular/core';

import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { ImageComponent } from '@frontend/vanilla/shared/image';

import { RtmsCtaActionComponent } from './rtms-cta-action.component';
import { RtmsLayerComponentBase } from './rtms-layer-component-base';

@Component({
    imports: [RtmsCtaActionComponent, ImageComponent, IconCustomComponent],
    selector: 'lh-rtms-layer-toaster',
    templateUrl: 'rtms-layer-toaster.component.html',
})
export class RtmsLayerToasterComponent extends RtmsLayerComponentBase {
    @Output() onManualClose: EventEmitter<any> = new EventEmitter();

    override close() {
        this.onManualClose.emit();
    }
}
